var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogleMarkerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 34.338,
    height: 47,
    viewBox: "0 0 34.338 47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_13957",
    "data-name": "Group 13957",
    transform: "translate(-836.501 -861)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_26",
    "data-name": "Ellipse 26",
    transform: "translate(843 868)",
    fill: "#fdb713",
    stroke: "#707070",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 10.5,
    cy: 10.5,
    r: 10,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Livello_110",
    transform: "translate(816.512 861)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_9166",
    "data-name": "Path 9166",
    d: "M45.421,17.091a8.584,8.584,0,1,1-8.584-8.545,8.566,8.566,0,0,1,8.584,8.545m8.907,0A17.169,17.169,0,1,0,23.948,28.006L37.173,47,50.591,27.729a16.89,16.89,0,0,0,1.322-1.9l.136-.194h-.022a16.956,16.956,0,0,0,2.3-8.546",
    fill: "#333"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleMarkerIcon);
export default __webpack_public_path__ + "static/media/google-marker-icon.f3bec94e5062b672dcb94e04f05bfbf8.svg";
export { ForwardRef as ReactComponent };